module.exports = __webpack_public_path__ + "img/c7e086b7e79e450391c7dbb9d3cb2c01.cbfd257e.png";